import { type ReactNode } from 'react'
import CookieScript from '../components/CookieScript'

const GTM_ID = 'GTM-WZLN3V4'

export const App = ({ script, locale, children }: { script: React.ElementType; locale: string; children: ReactNode }) => {
  const Script = script
  return (
    <>
      <CookieScript as={script} locale={locale} />
      {children}
      <Script
        id="dataLayer"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];`,
        }}
      />
      <Script
        id="gtag-base"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${GTM_ID}');
          `,
        }}
      />
      <noscript>
        <iframe
          title="gtag"
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
    </>
  )
}
